import React, { Component } from 'react';
import Resizable from 're-resizable';

import * as EditorHelpers from '../helpers/Editor';

class Image extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: props.height,
      width: props.width,
    };
  }

  render() {
    const {
      selected,
      alt,
      width = 100,
      editor,
      height = 100,
      ...rest
    } = this.props;

    if (!selected) {
      return <img width={width} height={height} alt={alt} {...rest} />;
    }

    return (
      <Resizable
        className="editor-image-resizable"
        size={{ width, height }}
        onResizeStop={(e, direction, ref, d) => {
          editor.change(change => {
            const image = change.value.inlines.first();
            const newWidth = parseInt(width, 10) + d.width;
            const newHeight = parseInt(height, 10) + d.height;
            EditorHelpers.mergeData(image, change, {
              data: { width: newWidth, height: newHeight },
            });
          });
        }}
      >
        <div className="handle handle-top-left" />
        <div className="handle handle-top-right" />
        <div className="handle handle-bottom-left" />
        <div className="handle handle-bottom-right" />
        <img width="100%" height="100%" alt={alt} {...rest} />
      </Resizable>
    );
  }
}

Image.defaultProps = {
  alt: 'Image',
};

export default Image;



// WEBPACK FOOTER //
// ./src/pages/lettersetup/components/Image.js